const MarqueeRow = ({ items }) => (
  <div className="flex shrink-0 items-center">
    {items.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-display text-2xl md:text-4xl font-semibold text-slate-500/70">
          {item}
        </span>
        <span className="h-2 w-2 rotate-45 bg-electric/60" aria-hidden="true" />
      </span>
    ))}
  </div>
);

export const Marquee = ({ items }) => (
  <div
    data-testid="editorial-marquee"
    className="relative overflow-hidden border-y border-lineblue bg-surface/60 py-7"
  >
    <div className="flex w-max animate-marquee">
      <MarqueeRow items={items} />
      <MarqueeRow items={items} />
    </div>
  </div>
);

export default Marquee;
